"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.array.find");require("core-js/modules/es6.function.name");require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable");











































































var _lodash = _interopRequireDefault(require("lodash"));
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { searchData: { type: '', productionCompanyName: '', moduleCode: '', page: 1, rows: 10 }, //搜索表单
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页数据
      companyList: [], //厂商列表
      showDialog: false, //是否显示新增||编辑弹窗
      tableColumns: [{ prop: 'type', label: '模块类型', formatter: _formatter.hardwareModuleTypeFormatter }, { prop: 'moduleCode', label: '型号' }, { prop: 'productionCompanyName', label: '厂商名称' }, { prop: 'productionCompanyCode', label: '厂商编码' }, { prop: 'remark', label: '备注' }], //表格信息
      list: [], //表格数据
      moduleForm: { id: 0, productionCompanyId: '', type: '', moduleCode: '', remark: '' }, //新增||编辑固件模块表单
      moduleFormRule: { productionCompanyId: [{ required: true, message: '请选择厂商名称编码', trigger: ['change'] }], type: [{ required: true, message: '请选择模块类型', trigger: ['change'] }], moduleCode: [{ required: true, message: '请填写模块型号', trigger: ['change', 'blur'] }] }, //表单验证规则
      typeList: [{ value: '1', label: '中心板' }, { value: '2', label: 'WiFi板' }, { value: '3', label: '语音板' }, { value: '4', label: '机芯板' },
      {
        value: '5',
        label: '小腿板' }],

      //模块类型列表
      showType: false, //是否显示新增模块类型弹窗
      typeForm: {
        name: '' },
      //新增模块类型表单
      typeFormRule: {
        name: [{
          required: true,
          message: '请填写模块类型名称',
          trigger: ['blur', 'change'] }] },

      //新增模块类型表单验证规则
      moduleTypeList: [], //模块类型列表
      currentHardware: '' //当前编辑的硬件模块
    };
  },

  mounted: function mounted() {
    this.initPage();
  },

  methods: {
    /**
              * 页面初始化
              */
    initPage: function initPage() {
      this.fetchModuleTypeDownList();
      this.fetchHardwareModuleList();
      this.fetchProductionCompanyDorpdownList();
    },

    /**
        * 获取模块菜单列表
        */
    fetchHardwareModuleList: function fetchHardwareModuleList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/hardwareModule', params, function (res) {
        _this.list = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 获取所有厂商列表
        */
    fetchProductionCompanyDorpdownList: function fetchProductionCompanyDorpdownList() {var _this2 = this;
      this.getData('/api/productionCompany/getDownList', {}, function (res) {
        _this2.companyList = res;
      });
    },

    /**
        * 获取模块类型下拉列表
        */
    fetchModuleTypeDownList: function fetchModuleTypeDownList() {var _this3 = this;
      this.getData('/api/hardwareModule/getModuleTypeDownList', {}, function (res) {
        _this3.moduleTypeList = res;
      });
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'type', '');
      this.$set(this.searchData, 'productionCompanyName', '');
      this.$set(this.searchData, 'moduleCode', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchHardwareModuleList();
    },

    /**
        * 每页size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.fetchHardwareModuleList();
    },

    /**
        * 页码-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.fetchHardwareModuleList();
    },

    /**
        * 编辑
        */
    onClickUpdate: function onClickUpdate(row) {
      this.showDialog = true;
      this.currentHardware = Object.assign({}, row);
      this.$set(this.moduleForm, 'id', row.id);
      this.$set(this.moduleForm, 'productionCompanyId', row.productionCompanyId);
      this.$set(this.moduleForm, 'type', row.type);
      this.$set(this.moduleForm, 'moduleCode', row.moduleCode);
      this.$set(this.moduleForm, 'remark', row.remark);
      if (parseInt(row.type) != 1 && parseInt(row.type) != 2 && parseInt(row.type) != 3) {
        this.typeList.push({ label: row.type, value: row.type });
      }
    },

    /**
        * 删除
        */
    onClickDelete: function onClickDelete(row) {var _this4 = this;
      this.$confirm('确定删除当前硬件模块？', '提示', { type: 'warning' }).then(function (res) {
        //删除硬件模块
        _this4.delData('/api/hardwareModule', { id: row.id }, function (res) {
          _this4.fetchHardwareModuleList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 弹窗关闭
        */
    onDialogClose: function onDialogClose() {var _this5 = this;
      this.$nextTick(function () {
        // console.log('moduleForm=====>',this.moduleForm)
        if (parseInt(_this5.moduleForm.type) != 1 && parseInt(_this5.moduleForm.type) != 2 && parseInt(_this5.moduleForm.type) != 3 && _this5.moduleForm.id) {
          var index = _this5.typeList.indexOf({ label: _this5.moduleForm.type, value: _this5.moduleForm.type });
          _this5.typeList.splice(index, 1);
        }
        Object.keys(_this5.moduleForm).forEach(function (key) {
          _this5.$set(_this5.moduleForm, key, key == 'id' ? 0 : '');
        });
        _this5.$refs.moduleForm.clearValidate();
      });
      this.showDialog = false;
      this.currentHardware = '';
    },

    /**
        * 新增||保存模块
        */
    onSubmitModule: function onSubmitModule() {var _this6 = this;
      this.$refs.moduleForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this6.moduleForm);
          if (params.id) {
            //编辑
            params.createTime = _this6.currentHardware.createTime;
            _this6.putData('/api/hardwareModule', params, function (res) {
              _this6.onDialogClose();
              _this6.fetchHardwareModuleList();
            });
          } else {
            //新增
            delete params['id'];
            _this6.postData('/api/hardwareModule', params, function (res) {
              _this6.onDialogClose();
              _this6.$set(_this6.searchData, 'page', 1);
              _this6.fetchHardwareModuleList();
            });
          }
        }
      });
    },

    /**
        * 新增模块类型弹窗关闭
        */
    onTypeDialogClose: function onTypeDialogClose() {var _this7 = this;
      this.$nextTick(function () {
        _this7.$set(_this7.typeForm, 'name', '');
        _this7.$refs.typeForm.clearValidate();
      });
      this.showType = false;
    },

    /**
        * 新增模块类型-保存
        */
    onSubmitType: function onSubmitType() {var _this8 = this;
      this.$refs.typeForm.validate(function (valid) {
        if (valid) {
          if (_this8.typeForm.name == '中心板' || _this8.typeForm.name == 'WiFi板' || _this8.typeForm.name == '语音板') {
            _this8.$message({
              message: '已存在当前模块类型',
              type: 'error' });

            return;
          }
          var findRes = _lodash.default.find(_this8.typeList, function (e) {return e.value == _this8.typeForm.name;});
          if (!findRes) {
            _this8.typeList.push({ label: _this8.typeForm.name, value: _this8.typeForm.name });
            _this8.$set(_this8.moduleForm, 'type', _this8.typeForm.name);
            _this8.showType = false;
          } else {
            _this8.$message({
              message: '已存在当前模块类型',
              type: 'error' });

          }
        }
      });
    } } };exports.default = _default;